import { render, staticRenderFns } from "./LeftContent.vue?vue&type=template&id=c720a4ba&scoped=true&"
import script from "./LeftContent.vue?vue&type=script&lang=js&"
export * from "./LeftContent.vue?vue&type=script&lang=js&"
import style0 from "./LeftContent.vue?vue&type=style&index=0&id=c720a4ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c720a4ba",
  null
  
)

export default component.exports